import { ISingleIdParams } from '../types/actionParams';
import { Request } from './Request';
import { IResult } from '../types/IResponse';

export class GetExtractDraftIdRequest extends Request<ISingleIdParams, IResult> {
  constructor(id: string) {
    super('getExtractDraftId', { id: id });
  }
}
